export default __webpack_public_path__ + "static/media/share.2962b699.svg";